export default {
  title: 'Shop-Domain',
  description:
    'Betreiben Sie die Online-Shops Ihrer Restaurants auf einer eigenen Domain statt auf der gemeinsamen Adresse — zum Beispiel pizza-mario.bestellen-bei-ihremarke.de. Sie legen einmal zwei DNS-Einträge an; jedes Restaurant, das Sie später hinzufügen, erhält seine Adresse automatisch.',
  read_only_description:
    'Die Domain, unter der die Shops der Restaurants dieses Partners laufen. Nur der Partner kann sie verbinden oder ändern.',
  read_only_empty: 'Dieser Partner hat keine Shop-Domain verbunden.',
  not_connected: {
    label: 'Domain für die Shops Ihrer Restaurants',
    hint: 'Eine Domain oder Subdomain, die Ihnen gehört, zum Beispiel bestellen-bei-ihremarke.de. Sie muss eine andere Domain sein als die, auf der die Apps Ihres Teams laufen — keine Subdomain davon.',
    placeholder: 'bestellen-bei-ihremarke.de',
    connect: 'Verbinden',
  },
  status: {
    pending_dns: 'Wartet auf DNS',
    active: 'Live',
    failed: 'Handlungsbedarf',
    disabled: 'Getrennt',
  },
  primary_badge: 'Primär',
  summary: {
    pending: 'Wir warten auf Ihre DNS-Einträge. Das dauert meist ein paar Minuten, manchmal einige Stunden.',
    failed:
      'Wir konnten nicht alle Einträge rechtzeitig bestätigen. Korrigieren Sie den unten markierten Eintrag und klicken Sie dann auf „Erneut prüfen“ — ab dann prüfen wir wieder.',
    failed_leave: 'Um stattdessen eine andere Domain zu verbinden, trennen Sie diese zuerst.',
    live: '{{host}} ist live.',
    primary: 'Jedes neue Restaurant erhält darunter automatisch seine Adresse.',
    standby:
      'Legen Sie sie als primäre Domain fest, damit jedes neue Restaurant sie automatisch erhält. Restaurants auf einer anderen Domain bleiben, wo sie sind.',
    regressed:
      '{{host}} ist live, aber ein Eintrag unten wird nicht mehr bestätigt. Ihre Shops sind weiterhin online — korrigieren Sie den Eintrag bei Ihrem DNS-Anbieter.',
  },
  instructions: {
    title: 'So legen Sie die Einträge an',
    step_provider:
      'Melden Sie sich dort an, wo das DNS von {{root}} verwaltet wird — meist beim Anbieter, bei dem Sie die Domain gekauft haben.',
    step_add: 'Legen Sie jeden Eintrag unten genau wie angezeigt an: Typ, Name und Wert.',
    step_check: 'Speichern Sie und klicken Sie dann auf „{{button}}“. Wir prüfen zusätzlich selbstständig.',
    tip_name:
      'Die meisten Anbieter erwarten im Namensfeld nur den Teil vor {{root}} — _foodamigos-verify und *. Der vollständige Name steht darunter, für Anbieter, die ihn verlangen.',
    tip_wildcard:
      'Der Eintrag * leitet jede Adresse unter {{root}} an Ihre Shops weiter, sodass Sie nie einen Eintrag pro Restaurant anlegen müssen.',
    tip_existing:
      'Bestehende Einträge für {{root}}, etwa für Ihre Website, Ihre E-Mails oder www, funktionieren weiter: Der Eintrag * gilt nur für Namen ohne eigenen Eintrag. Hat {{root}} bereits einen Eintrag *, ersetzen Sie ihn durch unseren.',
    tip_cloudflare:
      'Bei Cloudflare stellen Sie den CNAME-Eintrag auf „Nur DNS“ (graue Wolke), sonst können wir ihn nicht sehen.',
  },
  records: {
    title: 'Legen Sie diese DNS-Einträge für {{root}} bei Ihrem Domain-Anbieter an',
  },
  example: 'Ein Restaurant ist dann unter einer Adresse wie {{host}} erreichbar.',
  example_label: 'ihr-restaurant',
  buttons: {
    check_again: 'Erneut prüfen',
    make_primary: 'Als primär festlegen',
    unlink: 'Trennen',
    retry: 'Erneut versuchen',
  },
  primary_unavailable: 'Verfügbar, sobald die Domain live ist.',
  unlink_blocked_one:
    '{{count}} Restaurant läuft noch auf dieser Domain. Verschieben Sie es auf eine andere Domain, bevor Sie trennen.',
  unlink_blocked_other:
    '{{count}} Restaurants laufen noch auf dieser Domain. Verschieben Sie sie auf eine andere Domain, bevor Sie trennen.',
  unlink_confirm: {
    title: '{{host}} trennen?',
    description: 'Sie können {{host}} später erneut verbinden.',
    description_primary:
      'Neue Restaurants erhalten wieder eine Adresse auf der gemeinsamen Domain. Sie können {{host}} später erneut verbinden.',
    ok: 'Trennen',
  },
  toasts: {
    load_error: 'Ihre Shop-Domain konnte nicht geladen werden',
    load_error_read_only: 'Die Shop-Domain dieses Partners konnte nicht geladen werden',
    connected: 'Domain verbunden — legen Sie jetzt die Einträge unten an',
    connect_failed: 'Die Domain konnte nicht verbunden werden',
    check_started: 'Wird erneut geprüft…',
    check_failed: 'Die Prüfung konnte nicht gestartet werden. Versuchen Sie es in einer Minute erneut.',
    primary_set: 'Neue Restaurants erhalten jetzt diese Domain',
    primary_failed: 'Die Domain konnte nicht als primäre Domain festgelegt werden',
    unlinked: 'Domain getrennt',
    unlink_failed: 'Die Domain konnte nicht getrennt werden',
    unlink_has_restaurants_one:
      '{{count}} Restaurant läuft noch auf {{host}}: {{names}}. Verschieben Sie es auf eine andere Domain, bevor Sie trennen.',
    unlink_has_restaurants_other:
      '{{count}} Restaurants laufen noch auf {{host}}: {{names}}. Verschieben Sie sie auf eine andere Domain, bevor Sie trennen.',
    gone: '{{host}} ist nicht mehr verbunden — die Domain wurde möglicherweise in einem anderen Tab getrennt.',
  },
};
